import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IBeAnInvestorState } from "./types";

export type BeAnInvestorPayload = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
};

export type VerifyInvestorPayload = BeAnInvestorPayload & {
  otp: string;
  orderId: string;
};

const initialState: IBeAnInvestorState = {
  investor: {},
  verifyInvestor: {},
};

const slice = createSlice({
  name: "BeAnInvestor",
  initialState,
  reducers: {
    beAnInvestor(state, action: PayloadAction<BeAnInvestorPayload>) {
      state.investor.status = RequestStatus.RUNNING;
      state.investor.data = action.payload;
      state.investor.message = "";
      state.investor.alreadyExists = false;
      state.investor.requiresOtp = false;
      state.investor.orderId = undefined;
    },

    verifyInvestor(state, action: PayloadAction<VerifyInvestorPayload>) {
      state.verifyInvestor.status = RequestStatus.RUNNING;
      state.verifyInvestor.data = action.payload;
      state.verifyInvestor.message = "";
      state.verifyInvestor.error = undefined;
    },

    verifyInvestorSuccess(state, action) {
      state.verifyInvestor.status = RequestStatus.SUCCESS;
      state.verifyInvestor.data = action.payload?.data;
      state.verifyInvestor.message = action.payload?.message;
    },

    verifyInvestorFailed(state, action: PayloadAction<any>) {
      state.verifyInvestor.status = RequestStatus.ERROR;
      state.verifyInvestor.error = action.payload;
      state.verifyInvestor.message = action.payload?.message;
    },

    beAnInvestorSuccess(state, action) {
      state.investor.status = RequestStatus.SUCCESS;
      state.investor.data = action.payload?.data;
      state.investor.message = action.payload?.message;
      state.investor.alreadyExists = action.payload?.alreadyExists;
      state.investor.requiresOtp = action.payload?.requiresOtp;
      state.investor.orderId = action.payload?.orderId;
    },

    beAnInvestorFailed(state, action: PayloadAction<any>) {
      state.investor.status = RequestStatus.ERROR;
      state.investor.error = action.payload;
      state.investor.message = action.payload?.message;
      state.investor.alreadyExists = false;
      state.investor.requiresOtp = false;
      state.investor.orderId = undefined;
    },

    resetBeAnInvestorState(state) {
      state.investor = {
        status: RequestStatus.IDLE,
        data: null,
        error: undefined,
        message: "",
        alreadyExists: false,
        requiresOtp: false,
        orderId: undefined,
      };
      state.verifyInvestor = {
        status: RequestStatus.IDLE,
        data: null,
        error: undefined,
        message: "",
      };
    },
  },
});

export default slice.reducer;
export const {
  beAnInvestor,
  beAnInvestorFailed,
  beAnInvestorSuccess,
  resetBeAnInvestorState,
  verifyInvestor,
  verifyInvestorFailed,
  verifyInvestorSuccess,
} = slice.actions;
